import React from 'react';
import { Button, Tooltip } from 'antd';
import { LAYER_ACTIONS, eventBus } from '../../utils';

import './styles.scss';

export default () => {
  const onClick = (action) => {
    eventBus.emit('on-change-layer', action);
  };
  return (
    <div className="mo__object-layer">
      {LAYER_ACTIONS.map((item, index) => (
        <Tooltip title={item.title} key={index} placement="topLeft">
          <Button onClick={() => onClick(item.action)} className="btn">
            <img src={item.icon} alt="" />
          </Button>
        </Tooltip>
      ))}
    </div>
  );
};
